import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Params } from '@angular/router';
import { ApiConfig } from '~shared/constants';
import { select, Store } from '@ngrx/store';
import * as fromBrandPlp from '~app/modules/brand-plp/store';
import { Observable } from 'rxjs';

enum ZeroResultPageType {
  isExpired = 'isExpired',
  hasFilters = 'hasFilters',
  isNoFood = 'isNoFood',
  isSearch = 'isSearch',
  isOther = 'isOther'
}

const zeroResultTitleText = 'CATALOG.CATALOG_PAGE.ZERO_RESULT.SEARCH.TITLE';
const zeroResultSubtitleText = 'CATALOG.CATALOG_PAGE.ZERO_RESULT.SEARCH.SUBTITLE';
const zeroResultExpiredPageTitle = 'CATALOG.CATALOG_PAGE.ZERO_RESULT.EXPIRED_PAGE.TITLE';
const zeroResultExpiredPageSubTitle = 'CATALOG.CATALOG_PAGE.ZERO_RESULT.EXPIRED_PAGE.SUBTITLE';
const zeroResultFilterPageTitle = 'CATALOG.CATALOG_PAGE.ZERO_RESULT.FILTER.TITLE';
const zeroResultFilterPageSubTitle = 'CATALOG.CATALOG_PAGE.ZERO_RESULT.FILTER.SUBTITLE';
const zeroResultFoodSoonPageTitle = 'CATALOG.CATALOG_PAGE.ZERO_RESULT.FOOD_SOON.TITLE';
const zeroResultFoodSoonPageSubTitle = 'CATALOG.CATALOG_PAGE.ZERO_RESULT.FOOD_SOON.SUBTITLE';

const ZERO_RESULT_INFO = () => ({
  isExpired: {
    title: zeroResultExpiredPageTitle,
    subTitle: zeroResultExpiredPageSubTitle,
    imageUrl: null
  },
  hasFilters: {
    title: zeroResultFilterPageTitle,
    subTitle: zeroResultFilterPageSubTitle,
    imageUrl: null
  },
  isNoFood: {
    title: zeroResultFoodSoonPageTitle,
    subTitle: zeroResultFoodSoonPageSubTitle,
    imageUrl: null
  },
  isSearch: {
    title: zeroResultTitleText,
    subTitle: zeroResultSubtitleText,
    imageUrl: `${ApiConfig.CDN_IMAGE_URL()}/search-no-result/no-result@1x.png`
  },
  // For now, fall back to the default search message
  isOther: {
    title: zeroResultTitleText,
    subTitle: zeroResultSubtitleText,
    imageUrl: null
  }
});

@Component({
  selector: 'app-search-zero-result',
  templateUrl: './zero-result.component.html',
  styleUrls: ['./zero-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZeroResultComponent implements OnInit {
  @Input() queryParams: Params;
  @Input() isMobileOrTablet: boolean;

  shouldShowNoFoodResult$: Observable<boolean>;
  private _zeroResultInfo: {
    title: string,
    subTitle: string,
    imageUrl: string
  };

  get zeroResultInfo() {
    return this._zeroResultInfo;
  }

  constructor(private store: Store<fromBrandPlp.BrandPLPPageState>) {}

  ngOnInit(): void {
    this.shouldShowNoFoodResult$ = this.store.pipe(select(fromBrandPlp.shouldShowNoFoodResult));
    this.shouldShowNoFoodResult$.subscribe((isNoFoodResult: boolean) => {
      this.setZeroResultInfo(isNoFoodResult);
    });
  }

  private getZeroResultPageType(isNoFoodResult: boolean): ZeroResultPageType {
    const { hasFilters, isExpiredPage } = this.calculateHasFilterAndIsExpiredPage();

    if (isExpiredPage) {
      return ZeroResultPageType.isExpired;
    }

    if (hasFilters) {
      return ZeroResultPageType.hasFilters;
    }

    // logging reason why we have this case
    console.error('Zero Result: No idea why we have zero result, to be checked -->  ', this.queryParams);
    return ZeroResultPageType.isOther;
  }

  private setZeroResultInfo(isNoFoodResult: boolean): void {
    const type = this.getZeroResultPageType(isNoFoodResult);
    this._zeroResultInfo = ZERO_RESULT_INFO()[type];
  }

  private calculateHasFilterAndIsExpiredPage(): { hasFilters: boolean, isExpiredPage: boolean } {
    const filters = this.queryParams.filter || {};
    const hasPromoTag: boolean = filters.promoTag || false;
    const hasFilters = !!(filters.options || filters.price || filters.promotion);
    const isExpiredPage: boolean = !hasFilters && hasPromoTag;

    return {
      hasFilters,
      isExpiredPage
    };
  }
}
